import { render } from "./DeepSeaPosition.vue?vue&type=template&id=4a5dad5a"
import script from "./DeepSeaPosition.vue?vue&type=script&lang=js"
export * from "./DeepSeaPosition.vue?vue&type=script&lang=js"

import "./DeepSeaPosition.vue?vue&type=style&index=0&id=4a5dad5a&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__